var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("filter-item " + _vm.필터하나),style:(("background-image:url(" + _vm.업로드이미지 + ")")),on:{"click":_vm.boxClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }